export default __webpack_public_path__ + "static/media/Armbands of Bristling Ire.89aa3867.jpg";